import * as React from 'react'
import { connect } from 'react-redux'

import { Translation as T } from '../Other/Translation'

export interface TranslationPropsInterface {
  translationKey: string
  language: string
}

class InternalTranslation extends React.Component<TranslationPropsInterface, {}> {
  public render(): JSX.Element {
    return <span data-translation={this.props.translationKey}>{T.l(this.props.translationKey)}</span>
  }
}

export const Translation = connect<{ language: string }, {}, any>((state) => {
  return {
    language: state.language,
  }
})(InternalTranslation)
